export const lifeTranslations = {
  // 生活服务相关翻译
  "lifeServices": {
    en: "Life Services",
    zh: "生活服务"
  },
  "lifeServicesTitle": {
    en: "Essential Life Services in Penang",
    zh: "槟城必备生活服务"
  },
  "lifeServicesDesc": {
    en: "Access to essential services for comfortable living in Penang",
    zh: "获取在槟城舒适生活所需的基本服务"
  },
  "livingInPenang": {
    en: "Living in Penang",
    zh: "在槟城生活"
  },
  "livingInPenangDesc1": {
    en: "Penang offers a high quality of life with modern amenities combined with rich cultural heritage.",
    zh: "槟城提供高品质生活，现代设施与丰富的文化遗产相结合。"
  },
  "livingInPenangDesc2": {
    en: "Our Life Services team helps you navigate essential services to make your transition to life in Penang smooth and hassle-free.",
    zh: "我们的生活服务团队帮助您了解必要服务，使您顺利过渡到槟城的生活，无后顾之忧。"
  },
  "ourLifeServices": {
    en: "Our Life Services",
    zh: "我们的生活服务"
  },
  "healthcareInfo": {
    en: "Healthcare Information",
    zh: "医疗保健信息"
  },
  "bankingServices": {
    en: "Banking Services",
    zh: "银行服务"
  },
  "mobileInternet": {
    en: "Mobile & Internet Services",
    zh: "手机和互联网服务"
  },
  "shoppingInfo": {
    en: "Shopping Information",
    zh: "购物信息"
  },
  "utilityConnections": {
    en: "Utility Connections",
    zh: "公共设施连接"
  },
  "essentialLifeServices": {
    en: "Essential Life Services",
    zh: "必要生活服务"
  },
  "essentialServices": {
    en: "Essential Services",
    zh: "基本服务"
  },
  "healthcare": {
    en: "Healthcare",
    zh: "医疗保健"
  },
  "healthcareDesc": {
    en: "Penang offers excellent healthcare facilities with both public and private options available to residents and visitors.",
    zh: "槟城提供优质的医疗设施，居民和游客都可以使用公立和私立医疗服务。"
  },
  "healthcareGuide": {
    en: "Complete Healthcare Guide",
    zh: "完整医疗保健指南"
  },
  "privateHospitals": {
    en: "Private hospitals with international standards",
    zh: "符合国际标准的私立医院"
  },
  "publicHospitals": {
    en: "Public healthcare system with affordable rates",
    zh: "价格合理的公共医疗系统"
  },
  "medicalInsurance": {
    en: "Medical insurance options for expatriates",
    zh: "为外籍人士提供的医疗保险选择"
  },
  "doctorsEnglish": {
    en: "Most doctors speak English",
    zh: "大多数医生会说英语"
  },
  "pharmacies": {
    en: "Well-stocked pharmacies throughout the city",
    zh: "城市各处配备齐全的药店"
  },
  "banking": {
    en: "Banking",
    zh: "银行服务"
  },
  "bankingDesc": {
    en: "Comprehensive banking services with multiple local and international banks operating in Penang.",
    zh: "槟城有多家本地和国际银行运营，提供全面的银行服务。"
  },
  "bankingGuide": {
    en: "Banking Guide for Newcomers",
    zh: "新来者银行指南"
  },
  "majorBanks": {
    en: "Major local and international banks available",
    zh: "提供主要的本地和国际银行服务"
  },
  "documentsNeeded": {
    en: "Documents needed for account opening",
    zh: "开户所需文件"
  },
  "atmsAvailable": {
    en: "ATMs widely available across the island",
    zh: "岛上各处均有自动取款机"
  },
  "onlineBanking": {
    en: "Online and mobile banking services",
    zh: "网上和移动银行服务"
  },
  "creditCards": {
    en: "Credit card and loan facilities",
    zh: "信用卡和贷款服务"
  },
  "telecommunications": {
    en: "Telecommunications",
    zh: "电信服务"
  },
  "telecomDesc": {
    en: "Get connected with mobile services and internet providers in Penang for reliable communication.",
    zh: "在槟城连接手机服务和互联网提供商，获得可靠的通信服务。"
  },
  "telecomGuide": {
    en: "Telecommunications Guide",
    zh: "电信服务指南"
  },
  "majorProviders": {
    en: "Major mobile and internet service providers",
    zh: "主要手机和互联网服务提供商"
  },
  "touristSim": {
    en: "Tourist SIM cards and prepaid options",
    zh: "旅游SIM卡和预付费选项"
  },
  "homeInternet": {
    en: "Home internet connection services",
    zh: "家庭互联网连接服务"
  },
  "freeWifi": {
    en: "Free WiFi hotspots around the city",
    zh: "城市周围的免费WiFi热点"
  },
  "fourGCoverage": {
    en: "4G/5G coverage throughout Penang",
    zh: "覆盖整个槟城的4G/5G网络"
  },
  "shopping": {
    en: "Shopping",
    zh: "购物"
  },
  "shoppingDesc": {
    en: "From modern malls to traditional markets, Penang offers diverse shopping experiences for all preferences.",
    zh: "从现代购物中心到传统市场，槟城为所有偏好提供多样化的购物体验。"
  },
  "shoppingGuide": {
    en: "Penang Shopping Guide",
    zh: "槟城购物指南"
  },
  "shoppingMalls": {
    en: "Modern shopping malls with international brands",
    zh: "拥有国际品牌的现代购物中心"
  },
  "traditionalMarkets": {
    en: "Traditional markets for local products",
    zh: "提供本地产品的传统市场"
  },
  "groceryStores": {
    en: "Grocery stores and supermarkets",
    zh: "杂货店和超市"
  },
  "specialtyStores": {
    en: "Specialty stores for imported goods",
    zh: "进口商品专卖店"
  },
  "onlineShopping": {
    en: "Online shopping delivery options",
    zh: "网上购物配送选择"
  },
  "utilities": {
    en: "Utilities",
    zh: "公共事业"
  },
  "utilitiesDesc": {
    en: "Information about setting up and managing essential utilities for your accommodation in Penang.",
    zh: "关于在槟城住所设置和管理基本公共设施的信息。"
  },
  "utilitiesGuide": {
    en: "Utilities Setup Guide",
    zh: "公共设施设置指南"
  },
  "electricity": {
    en: "Electricity connection and billing",
    zh: "电力连接和账单"
  },
  "water": {
    en: "Water supply and payment options",
    zh: "供水和付款选择"
  },
  "internet": {
    en: "Internet and broadband providers",
    zh: "互联网和宽带提供商"
  },
  "mobilePhone": {
    en: "Mobile phone plans and coverage",
    zh: "手机套餐和覆盖范围"
  },
  "garbageDisposal": {
    en: "Garbage disposal and recycling",
    zh: "垃圾处理和回收"
  },
  "needHelp": {
    en: "Need Help with Life Services?",
    zh: "需要生活服务帮助？"
  },
  "needHelpDesc": {
    en: "Our team can assist you with setting up utilities, finding healthcare providers, banking services, and more.",
    zh: "我们的团队可以帮助您设置公共设施、寻找医疗保健提供商、银行服务等。"
  },
  "contactLifeServices": {
    en: "Contact Our Life Services Team",
    zh: "联系我们的生活服务团队"
  },
  "keyInformation": {
    en: "Key Information",
    zh: "关键信息"
  },
  "penangLifestyleAlt": {
    en: "Penang Lifestyle",
    zh: "槟城生活方式"
  }
};
